import { render } from "./AntepostEvent.vue?vue&type=template&id=816fe9ce&scoped=true"
import script from "./AntepostEvent.vue?vue&type=script&lang=js"
export * from "./AntepostEvent.vue?vue&type=script&lang=js"

import "./AntepostEvent.vue?vue&type=style&index=0&id=816fe9ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-816fe9ce"]])

export default __exports__